import React from 'react';
import cn from 'classnames';
import Routes from 'routes';
import { useHistory } from 'react-router';
import { IconButton, useMediaQuery } from '@material-ui/core';
import useTheme from '@material-ui/core/styles/useTheme';
import { useAppContext } from 'contexts/AppContext';
import { grey } from 'globals/colors';
import { ReactComponent as HamburgerMenuIcon } from 'assets/icons/ui/hamburger-menu.svg';
import { ReactComponent as Logo } from 'assets/icons/brand/fs-logotype.svg';
import FsDate from 'ui-elements/common-elements/FsDate';
import FsAvatarNavMenu from 'ui-elements/common-elements/FsAvatarNavMenu';
import FsNotificationButton from 'ui-elements/common-elements/FsNotificationButton';
import FsFlagsButton from 'ui-elements/common-elements/FsFlagsButton';
import {
  Title,
  TitleBox,
  DateWrapper,
  WrapperBox,
  ActionButtonsBox,
  SidePanelTriggerButton,
  MainRowBox,
  StyledIconButton,
  StyledIconButtonWrapper,
} from './TopBar.style-elements';
import { useStyles } from './TopBar.style';
import { getTitle } from './TopBar.utils';

interface TopBarProps {
  onSidePanelTriggerChange: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onSidePanelTriggerChange }) => {
  const { isBlocked, isStaging } = useAppContext();
  const { active: activeClass } = useStyles();
  const theme = useTheme();
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'), {
    noSsr: true, // fix for issue: [useMediaQuery] always returns false at the first call
  });
  const timestamp = new Date().getTime();
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const handleClick = (): void => {
    history.push(Routes.ROOT);
  };

  return (
    <WrapperBox>
      {!isBlocked && (
        <SidePanelTriggerButton className={cn({ [activeClass]: !isUpMd })}>
          <IconButton onClick={onSidePanelTriggerChange}>
            <HamburgerMenuIcon />
          </IconButton>
        </SidePanelTriggerButton>
      )}
      <MainRowBox>
        <TitleBox>
          {isBlocked ? (
            <StyledIconButtonWrapper>
              <StyledIconButton onClick={handleClick}>
                <Logo />
              </StyledIconButton>
            </StyledIconButtonWrapper>
          ) : (
            <>
              <Title>{getTitle(pathname)}</Title>
              <DateWrapper>
                <FsDate date={timestamp} withWeekday withYear color={grey.V3} />
              </DateWrapper>
            </>
          )}
        </TitleBox>
        <ActionButtonsBox>
          {/* <SearchPart /> */}
          {!isBlocked && <FsNotificationButton />}
          {isStaging && <FsFlagsButton />}
          <FsAvatarNavMenu />
        </ActionButtonsBox>
      </MainRowBox>
    </WrapperBox>
  );
};

export default TopBar;
